export default function TestController(
  $filter,
  $q,
  $rootScope,
  alerts,
  bcpDataService,
  confirmDialog,
  editTestDialog,
  ssDialogService
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.canEdit = true;
  vm.canDelete = true;
  vm.handleExpandTest = _handleExpandTest;
  vm.handleEditTest = _handleEditTest;
  vm.handleDeleteTest = _handleDeleteTest;

  function _handleExpandTest() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleEditTest($event) {
    bcpDataService.getTest(
      vm.test.assessmentTestId
    ).then((getTestResponse) => {
      ssDialogService.dialogs.bcp.editTestDialog = ssDialogService.alert(
        editTestDialog.getOptions($event, {
          assessmentId: vm.assessmentId,
          testTypes: $rootScope.testTypes,
          test: getTestResponse.data,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.editTestDialog);
    });
  }

  function _handleDeleteTest($event) {
    ssDialogService.dialogs.bcp.confirmDeleteTestDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Test?',
        // eslint-disable-next-line max-len
        message: `Are you sure you want to delete the test "${vm.test.testType.name}" from ${$filter('date')(vm.test.testDate, 'MM/dd/yyyy')} ?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteTestDialog);
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteTestDialog);
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _handleConfirmDelete() {
    return bcpDataService.deleteTest(vm.test.assessmentTestId)
      .then(() => {
        alerts.success('The Test has been deleted successfully.');
        $rootScope.$broadcast('refreshBCPAssessments');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred deleting the test.');
      });
  }
}

TestController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  'alerts',
  'bcpDataService',
  'confirmDialog',
  'editTestDialog',
  'ssDialogService'
];
